import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import ValuationCards from '../Valuations/ValuationCards';
import { ValuationCard, Valuation, ValuationSummaryCardData } from '../../models/Valuation';
import './ValuationCards.css';
import { useCurrency } from '../../components/CurrencyContext';
import PaidIcon from '@mui/icons-material/Paid';
import ShieldIcon from '@mui/icons-material/Shield';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const ValuationSummaryCard: React.FC<ValuationSummaryCardData> = ({
    title, type, currencyCode, lowerRange, upperRange, artworkCount
}) => {

        const [IconComponent, setIconComponent] = useState<any>(PaidIcon);
        const [modifierClass, setModifierClass] = useState<string>('');

        const formatValue = (valuationTotal: number) => {
            const valuationText =
                `${valuationTotal?.toLocaleString(undefined, { maximumFractionDigits: 0, })} ${currencyCode}`;

            return `${valuationText}`;
        };

        useEffect(() => {

            if (type == "acquisition") {
                setIconComponent(PaidIcon);
                setModifierClass('valuation-card--acquisition');
            } else {
                if (type == "insurance") {
                    setIconComponent(ShieldIcon);
                    setModifierClass('valuation-card--insurance');
                } else {
                    if (type == "fairMarketValue") {
                        setIconComponent(TrendingUpIcon)
                        setModifierClass('valuation-card--fmv');
                    } else {
                        setIconComponent(PaidIcon);
                        setModifierClass('valuation-card--acquisition');
                    }
                }
            }

        }, []);


    const renderCard = () => (
        <div className={`portfolio-card ${modifierClass}`}>
            <div className="valuation-card-header">
                <div className="valuation-card-icon">
                    <IconComponent fontSize="small" />
                </div>
                <div className="portfolio-card-title">{title}</div>
            </div>

            <div className="portfolio-card-value">
                {formatValue(lowerRange)}
            </div>
            <div className="portfolio-card-subtitle">
                {artworkCount} items
            </div>
        </div>
    );

    return (
            <>
            {renderCard()}
            </>
    );
};

    export default ValuationSummaryCard;
